module.exports = __webpack_public_path__ + "static/img/case-mobile-diagram-02.0236b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-mobile-diagram-02.png
// module id = 8ScR
// module chunks = 1